import { SelectedAccount, SolutionsType } from '@types';

export interface UserInputState {
	email?: string;
	planId?: string;
	promotionalCode?: string;
	acceptedDebitInAccount?: boolean;
	acceptedTermsAndConditionsBank?: boolean;
	acceptedTermsAndConditionsSoftware?: boolean;
	selectedAccount?: SelectedAccount;
	isValid?: boolean;
	hasIntegratedSolution?: boolean;
	solutionId?: SolutionsType;
}

export const userInputActions = {
	saveUserInput: '@userInput/saveUserInput',
	clearUserInput: '@userInput/clearUserInput',
};
